import axios from "axios";

import { CONVERSATIONS_ITEM_SEEN } from "./type";
import { MESSAGES } from "endpointsConst";

export const seenConversation = (el) => {
    return async (dispatch) => {
        try {
            axios
                .patch(`${MESSAGES}/isSeen`, {
                    userId: el.employee && el.employee.id,
                })
                .then(() => {
                    dispatch({
                        type: CONVERSATIONS_ITEM_SEEN,
                        payload: {
                            conversation_id: el.id,
                        },
                    });
                });
        } catch (e) {
            console.log(e);
        }
    };
};
